// src/api/settingsApi.js
import { settingsMockData } from "./mock/settingData";

/**
 * Mendapatkan konfigurasi aplikasi (Logo, Nama, dll)
 * Menggunakan pola Promise untuk simulasi network latency
 */
export const getSettingsData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      // Di produksi, ini akan menjadi: fetch('/api/settings').then(res => res.json())
      resolve(settingsMockData);
    }, 500); // Latency teliti 500ms
  });
};